// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-enter-active[data-v-abb9de30],\n.list-leave-active[data-v-abb9de30] {\n  transition: transform 1s;\n}\n.list-enter-from[data-v-abb9de30],\n.list-leave-to[data-v-abb9de30] {\n  opacity: 0;\n}\n.logos[data-v-abb9de30] {\n  width: auto;\n  max-width: 22%;\n  max-height: 45px;\n  margin-top: 3%;\n  margin-right: 5%;\n}\n#sponsor-logo[data-v-abb9de30] {\n  width: auto;\n  max-width: 100%;\n  max-height: 41px;\n  margin-top: 0.7rem;\n  margin-bottom: 1rem;\n}", ""]);
// Exports
module.exports = exports;
